import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import { AlertProps, Alert } from '@mui/material'

export type ScrollableAlertInteraction = { show: () => void }

export const ScrollableAlert = forwardRef(function MyInput(props: AlertProps, ref) {
  const alertRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => {
    return {
      show() {
        alertRef?.current?.scrollIntoView();
      },
    };
  }, []);

  return <Alert {...props} ref={alertRef} />;
});
